export const pillars = [
  {
    id: 'culture',
    title: 'Culture & Heritage',
    script: 'Nuestra cultura',
    body: 'We celebrate Honduran traditions, food, and art — creating spaces where our community connects, learns, and takes pride in its heritage. Through events and educational programming, we keep our culture thriving for the next generation.',
    theme: 'sun',
  },
  {
    id: 'economic',
    title: 'Economic Impact',
    script: 'Apoya lo nuestro',
    body: 'We support the growth of Honduran-owned businesses and creators by connecting them with new audiences, promoting local commerce, and opening doors to collaboration and advancement.',
    theme: 'flamingo',
  },
  {
    id: 'coalition',
    title: 'Coalition Building',
    script: 'Construyendo puentes',
    body: 'Lasting impact takes partnership. We work alongside organizations across LA to expand opportunity and better serve our community.',
    theme: 'catracho',
  },
] as const;
